import PostEventView from '@src/components/layout/admin/sections/post-event/post-event-view';
import React from 'react';

const PostEventViewPage = () => {
    return <PostEventView title="รายละเอียดคำขอกิจกรรม" />;
};

export default PostEventViewPage;
